<template>
  <el-select
    v-model="employee"
    placeholder="请选择"
    :multiple="multiple"
    filterable
  >
    <el-option-group
      v-for="group in employeeList"
      :key="group[0]"
      :label="group[0]"
    >
      <el-option
        v-for="item in group[1]"
        :key="item.userId"
        :label="item.userName"
        :value="item.userId"
      >
      </el-option>
    </el-option-group>
  </el-select>
</template>

<script>
import { post } from "../utils/request";
export default {
  name: "EmployeeSelect",
  props: ["depIdArr", "allowMultiple"],
  data() {
    return {
      placeholder: "请选择用户",
      multiple: this.allowMultiple,
      model: "1",
      employeeList: [],
      employee: "",
      departmentIdList: this.depIdArr,
    };
  },
  methods: {
    toMap() {
      let map = new Map();
      for (let i = 0; i < this.employeeList.length; i++) {
        let dn = this.employeeList[i].departmentName;
        if (!map.has(dn)) {
          let arr = new Array();
          arr.push(this.employeeList[i]);
          map.set(dn, arr);
        } else {
          let temp = map.get(dn);
          temp.push(this.employeeList[i]);
          map.set(dn, temp);
        }
      }
      return Array.from(map);
    },
    employeeSearch() {
      let employeeManage = sessionStorage.getItem("employeeManage");
      if (employeeManage != null && employeeManage != "") {
        this.employeeList = JSON.parse(employeeManage);
        return;
      }
      // let departmentIdList = [100];
      post("/employee/search", JSON.stringify(this.departmentIdList)).then(
        (res) => {
          if (res.code == 200) {
            this.employeeList = JSON.parse(res.data.employeeList);
            this.employeeList = this.toMap();
            sessionStorage.setItem(
              "employeeManage",
              JSON.stringify(this.employeeList)
            );
          }
        }
      );
    },
  },
  watch: {
    employee(newVal, oldVal) {
      this.$emit("employee", this.employee);
    },
  },
  created() {
    this.employeeSearch();
  },
};
</script>

<style scoped lang="scss">
</style>